import React from 'react';

import RichText from 'components/RichText/RichText';
import { IndentTextSection } from 'containers/PrivacyPage/PrivacyPage.types';

import * as S from './IndentTextSection.styles';

export interface IndentTextSectionProps {
  data: IndentTextSection;
}

const defaultProps: Partial<IndentTextSectionProps> = {};

const IndentTextSection: React.FunctionComponent<IndentTextSectionProps> = ({
  data,
}) => {
  return (
    <S.IndentTextSectionWrapper>
      {data.indentedText.map(block => (
        <S.Block key={block.title}>
          <S.Title>{block.title}</S.Title>
          <S.Content>
            <RichText richText={block.richText} />
          </S.Content>
        </S.Block>
      ))}
    </S.IndentTextSectionWrapper>
  );
};

IndentTextSection.defaultProps = defaultProps;

export default IndentTextSection;
